import { useTranslation } from 'react-i18next';

export default function SecurityFooter() {
  const { t } = useTranslation();

  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-3 px-4 py-4 md:flex-row md:justify-between md:px-6">
        <div className="flex items-center gap-2 text-center md:text-left">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
            <i className="ri-lock-2-line text-sm"></i>
          </span>
          <p className="max-w-xl text-xs leading-relaxed text-foreground-600">
            {t('common.secureFooter')}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-800">
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-shield-check-line text-[11px]"></i>
            </span>
            {t('common.secureBadge')}
          </span>
        </div>
      </div>
    </footer>
  );
}